module.exports = __webpack_public_path__ + "static/YYC-logo-6b335f0ce0b0174d8de6ef647e3c9036.jpg";